import { OrganizationRouteConfig } from './organizationRouteConfig';
import { OrganizationRouteLoader } from './organizationRouteInterface';

export function createOrganizationRouteLoader(
    config: Pick<OrganizationRouteConfig, 'repository'>
): OrganizationRouteLoader {
    const { repository } = config;
    return {
        useLoad(context) {
            const profileQuery = repository.account.profile.useLookup(context, {
                suspense: true,
                staleTime: Infinity,
            });
            return {
                profile: profileQuery,
            };
        },
    };
}
